import React, { useState, useEffect } from 'react'

// ----- Packages ----- 
import { v4 as uuidv4 } from 'uuid';

export default function LabelSector({ label, selectedSectors, setSelectedSectors, isActiveSectors, index }) {

  const [isActive, setIsActive] = useState(false)

  // ----- If the selector corresponds to the label: I activate it -----
  useEffect(() => {
    if (selectedSectors.length > 0) {
      selectedSectors.forEach(element => {
        if (element === label.value) {
          setIsActive(true)
        }
      });
    }
  }, [selectedSectors, label.value])

  // ----- If the label is active, I add it to the filters, otherwise I remove it -----
  useEffect(() => {
    if (isActive && !selectedSectors.includes(label.value)) {
      setSelectedSectors(arr => [...arr, label.value]);
    } else if (!isActive) {
      setSelectedSectors(selectedSectors.filter(item => item !== label.value))
    }
    // eslint-disable-next-line
  }, [isActive])

  // ----- If the 'all' filter is selected, I activate the label -----
  useEffect(() => {
    if (!isActiveSectors) {
      setIsActive(false)
    }
  }, [isActiveSectors])


  return (
    <button
      key={index}
      id={uuidv4()}
      value={label.value}
      className={`btn-label ${isActive ? "is-active" : ""}`}
      onClick={() => setIsActive(isActive ? false : true)}
    >
      {label.title}
    </button>

  )
}
